import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown"]
  static values = {
    open: { type: Boolean, default: false }
  }

  connect() {
    this.closeOnClickOutside = this.closeOnClickOutside.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnClickOutside)
    this.unlockScroll()
  }

  toggle(event) {
    event.stopPropagation()
    this.openValue = !this.openValue
  }

  openValueChanged() {
    if (this.openValue) {
      this.show()
    } else {
      this.hide()
    }
  }

  show() {
    this.dropdownTarget.classList.add("is-open")
    document.addEventListener("click", this.closeOnClickOutside)
    this.lockScroll()
  }

  hide() {
    this.dropdownTarget.classList.remove("is-open")
    document.removeEventListener("click", this.closeOnClickOutside)
    this.unlockScroll()
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.openValue = false
      return
    }
    // Close if clicking on the dropdown backdrop (mobile bottom sheet ::before)
    if (event.target === this.dropdownTarget) {
      this.openValue = false
    }
  }

  select(event) {
    // Form submission is handled by the browser
    // Close dropdown immediately for better UX
    this.openValue = false
  }

  lockScroll() {
    if (window.innerWidth < 768) {
      document.body.style.overflow = "hidden"
    }
  }

  unlockScroll() {
    document.body.style.overflow = ""
  }
}
